export default {
	type: 'object',
	properties: {
		id: { type: 'string' },
		token: { type: 'string' },
	},
	required: ['id'],
	additionalProperties: false,
}
